var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data && _vm.data.length <= 0)?_c('div',[_c('b-card',{staticClass:"mt-0 border-0 text-center bg-secoundary"},[_c('img',{attrs:{"src":require("@/assets/inbox (1).png"),"width":"30","alt":""}}),_vm._v(" "),_c('h6',{staticClass:"text-black-50 text-light"},[_vm._v("Nada que mostrar")])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83bbc5b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/TableEmpty.vue
// module id = null
// module chunks = 